<script>
import VAppLayout from "@/layouts/VAppLayout.vue";
import VReviewAdd from "@/modules/review/components/VReviewAdd.vue";
import VContainer from "@/components/ui/VContainer.vue";
import VPaymentError from "@/components/ui/VPaymentError.vue";
import loader from "@/plugins/loader.plugin";
import VButton from "@/components/ui/VButton.vue";

const QUERY_COUNT_LIMIT = 15

export default {
    name: "PaymentResultTab",
    components: {
      VButton,
        VContainer,
        VReviewAdd,
        VAppLayout,
        VPaymentError,
    },
    data() {
        return {
            checking: null,
            interval: null,
            intervalTimeMS: 4000,
            status: null,
            queryCounter: 0,
            addReview: false,
            orderNumber: '',
            paymentError: false,
            errorTimestamp: null,
            firstRequestTimestamp: null
        }
    },
    mounted() {
        this.checking = true
      if(this.checking) {
        loader.show();

        let order_id = this.$route.query.order_id;

        if(this.$route.query.instant_update) {
          this.fetchOrderStatus()
        }

        if(!order_id) {
          //get last order_id from local storage
          order_id = this.$store.getters['cartStore/getLastOrderId'];

          if(!order_id) {
            this.getOrderIdFromFingerprint();
          } else {
            this.processOrderStatus(order_id);
          }
        } else {
          this.processOrderStatus(order_id);
        }
      }
    },
    computed: {
        computedCompanyData: function () {
            return this.$store.getters['getCompanyData']
        },
        isSelfPickup() {
          return this.$store.getters['cartStore/getDeliveryMethod'] && this.$store.getters['cartStore/getDeliveryMethod'].self_pickup === 1;
        }
    },
    watch: {
        checking: function (val) {
            if (!val) clearInterval(this.interval)
        },
        queryCounter: function (val) {
            if (+val === +QUERY_COUNT_LIMIT) {
                this.handlePaymentError(this.firstRequestTimestamp);
            }
        }
    },
    methods: {
      showReviewForm() {
        console.log('showReviewForm');
        this.addReview = true
      },


      fetchOrderStatus() {
        if(!this.checking) {
          return
        }
        
        // Записуємо час першого запиту
        if (!this.firstRequestTimestamp) {
          this.firstRequestTimestamp = new Date().toLocaleString('pl-PL', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
          });
        }
        
        this.$store.dispatch('cartStore/FETCH_IF_PAYED_ORDER_CHANGE_STATUS', this.$route.query.order_id)
            .then(resp => {
              if (resp && resp.status === 'error') {
                this.handlePaymentError();
              } else {
                this.processCompanyData(resp);
              }
            })
            .catch(error => {
              console.log('Error in fetchOrderStatus:', error);
            });
      },
      processCompanyData(resp) {
        if(!this.checking) {
          return
        }

        this.setLocaleData(resp);

        if (resp.order.status === "success") {
          this.status = resp.order.status
          this.checking = false
          this.orderNumber = resp.order.order_number


          this.setLocaleData(resp, true);

          this.$store.dispatch('cartStore/CLEAR_CART')
          this.$store.dispatch('cartStore/CLEAR_ORDERS')
        }
      },
      setLocaleData( resp, $hideLoader = false) {
        if (this.$store.getters['getCompanyName'] === null || this.$store.getters['getCompanyData'] === null) {
          let queryCn = resp.cn || null,
              queryT = resp.order.table_id || null;


          // initial loading
          if (queryCn !== null) {
            this.$store.dispatch('FETCH_AND_SET_COMPANY_NAME', queryCn).then(() => {
              this.$store.dispatch('FETCH_AND_SET_INITIAL_APP_DATA', queryT).then(() => {
                this.$store.dispatch('FETCH_AND_SET_TABLE_DATA', queryT).then(
                  () => {
                    if ($hideLoader) {
                      loader.hide()
                    }
                  }
                )
              })
            })
          }
        }  else if ($hideLoader) {
          loader.hide()
        }
      },
      processOrderStatus(order_id) {
        if (!this.firstRequestTimestamp) {
          this.firstRequestTimestamp = new Date().toLocaleString('pl-PL', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
          });
        }


        
        this.interval = setInterval(() => {
          this.queryCounter++

          this.$store.dispatch('cartStore/FETCH_IF_PAYED_ORDER_CHANGE_STATUS', order_id)
              .then(resp => {
                if (resp && resp.status === 'error') {
                  this.handlePaymentError();
                } else {
                  this.processCompanyData(resp);
                }
              })
              .catch(error => {
                console.log('Error in processOrderStatus:', error);
                // this.handlePaymentError();
              });

        }, this.intervalTimeMS)
      },
      handlePaymentError(customTimestamp = null) {
        if (this.interval) {
          clearInterval(this.interval);
          this.interval = null;
        }
        
        this.checking = false;
        this.paymentError = true;
        
        this.errorTimestamp = customTimestamp || new Date().toLocaleString('pl-PL', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit'
        });

        this.$store.dispatch('cartStore/CLEAR_CART')
        this.$store.dispatch('cartStore/CLEAR_ORDERS')

        loader.hide();
      },
      getOrderIdFromFingerprint() {

        this.$store.dispatch('cartStore/FETCH_ORDER_ID_FROM_FINGERPRINT')
            .then(resp => {
              if(resp) {
                this.processOrderStatus(resp);
              } else {
                console.log('Error: Order ID not received');
              }
            })
            .catch(error => {
              console.log('Error fetching Order ID:', error);
            });
      }
    }
}
</script>

<template>
    <VAppLayout>
        <!-- Payment Error Screen -->
        <VPaymentError 
            v-if="paymentError" 
            :timestamp="errorTimestamp"
        />
        
        <!-- Normal Content -->
        <VContainer v-else>
            <section class="payment-result" v-if="$store.getters['getIsModeQSR'] || $store.getters['getIsModeSOT'] || $store.getters['getIsModeHOT']">
              <div class="payment-result_title">
                <h6 v-if="checking && status === null">
                  {{ $t('pages.paymentResult.checking') }}
                </h6>
                <h6 v-else-if="!checking && (status === 'success')">
                  {{ $t('pages.paymentResult.gratification') }}
                </h6>
                <div class="payment-result_title-logo">
                  <img :src="computedCompanyData.locale.logo" :alt="`Logo of ${computedCompanyData.locale.name}`">
                </div>
              </div>
              <div v-if="checking" class="payment-result_content plug">
                <p>
                  {{ $t('pages.paymentResult.checkingStatus') }}
                </p>
              </div>

              <div v-if="!addReview && !checking && (status === 'success')" class="success-block">
                <img src="@/assets/img/ic_round-done.png" alt="" class="success-image">
                <p v-if="isSelfPickup" class="success-text">
                  {{ $t('pages.paymentResult.successCommentSelfPickup') }}
                </p>
                <p v-else class="success-text">
                  {{ $t('pages.paymentResult.successCommentDelivery') }}
                </p>
                <h3>{{ $t('pages.paymentResult.orderNumber') }}<br>#{{ orderNumber }}</h3>
              </div>

              <div v-if="addReview" class="payment-result_content">
                <VReviewAdd
                    :is-restaurant-logo-visible="false"/>
              </div>
              <div v-else-if="!checking" class="cart_options" @click="showReviewForm">
                <VButton type="violet" >
                  {{ $t('pages.paymentResult.review') }}
                </VButton>
              </div>
            </section>
            <section class="payment-result" v-else>
                <div class="payment-result_title">
                    <h6 v-if="checking && status === null">
                        {{ $t('pages.paymentResult.checking') }}
                    </h6>
                    <h6
                        v-else-if="!checking &&
                        (status === 'success')"
                    >
                        {{ $t('pages.paymentResult.gratification') }}
                    </h6>
                    <div class="payment-result_title-logo">
                        <img :src="computedCompanyData.locale.logo" :alt="`Logo of ${computedCompanyData.locale.name}`">
                    </div>
                </div>
                <div
                    v-if="checking"
                    class="payment-result_content plug">
                    <p>
                        {{ $t('pages.paymentResult.checkingStatus') }}
                    </p>
                </div>
                <div
                    v-else-if="!checking && (status === 'success')"
                    class="payment-result_content">
                    <VReviewAdd
                        :is-restaurant-logo-visible="false"/>
                </div>
            </section>
        </VContainer>
    </VAppLayout>
</template>

<style lang="scss" scoped>

@import "@/scss/assets/variables";

.payment-result {
    padding: 16px 0;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 42px;

    &_title {
        display: flex;
        justify-content: space-between;
        align-items: center;

        h6 {
            margin: 0;
            font-weight: 700;
            font-size: 32px;
        }

        &-logo {
            width: 100px;
            height: 60px;
            overflow: hidden;

            img {
                width: 100%;
                height: 100%;
                object-fit: contain;
            }
        }
    }

    &_content {
        display: flex;
        flex-direction: column;
        gap: 32px;
        align-items: center;

        p {
            min-height: 70px;
            border: 2px solid $color_dove_gray;
            border-radius: 12px;
            padding: 12px;
            text-align: center;
            color: $color_dove_gray;
            font-size: 14px;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }

  .success-block {
    height: 100%;
    text-align: center;
    padding-top: 10%;

    .success-text {
      padding: 5%;
    }

    h3 {
      color: #7019FD;
      font-size: 2rem;
      line-height: 1.3;
    }
  }
}

.cart_options {
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-top: auto;

  .btn {
    height: 50px !important;
  }
}

</style>
